<template>
  <el-container>
    <el-container>
      <el-header height="60">
        <CommonHeader />
      </el-header>
      <el-main height="">
        <div class="personal-container">
          <div class="header-handle">
            <el-button size="small" type="primary" @click="editClick('password')">修改密码</el-button>
            <el-button size="small" plain @click="editClick('back')">返回</el-button>
          </div>
          <div class="personal-info">
            <div class="person-head">
              <div :style="{ backgroundImage: `url(${userinfo['avatar']})` }" class="div-photo person-head-img"></div>
              <div class="select-picture" @click="changePersonImage">
                <div>点击更换头像</div>
              </div>
            </div>
            <div class="person-body">
              <div class="person-name">{{ userinfo["username"] }}</div>
              <div class="person-detail">邮箱: {{ userinfo["email"] }}</div>
            </div>
          </div>
          <div class="segmentation"></div>
          <div class="section">
            <div class="section-header">
              <div class="section-mark" />
              <div class="section-title">基本信息</div>
            </div>
            <div class="content">
              <div class="info-cell">
                <div align="stretch" class="info-cell-box">
                  <div class="info-cell-box-name">登录名：</div>
                  <div class="info-cell-box-value">{{ userinfo["username"] }}</div>
                </div>
              </div>
              <div class="info-cell">
                <div align="stretch" class="info-cell-box">
                  <div class="info-cell-box-name">邮箱：</div>
                  <div class="info-cell-box-value">{{ userinfo["email"] }}</div>
                </div>
              </div>
              <div class="info-cell">
                <div align="stretch" class="info-cell-box">
                  <div class="info-cell-box-name">上次登录时间：</div>
                  <div class="info-cell-box-value">{{ last_login_time }}</div>
                </div>
              </div>
              <div class="info-cell">
                <div align="stretch" class="info-cell-box">
                  <div class="info-cell-box-name">上次登录IP地址：</div>
                  <div class="info-cell-box-value">{{ userinfo_last["lastLoginIp"] }}</div>
                </div>
              </div>
            </div>
          </div>
          <input id="inputFile" ref="uploadInput" type="file" accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadFile" />
          <change-pass :show="showEditPassword" @close="showEditPassword = false" />
          <image-edit :show="showEditImage" :file="editFile" :image="editImage" @save="submitCropperImage" @close="showEditImage = false" />
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import CommonHeader from "../../components/Common-Header"
// import EditInfo from "./components/EditInfo"
import ChangePass from "./components/ChangePassword"
import ImageEdit from "./components/ImageEdit"
import { updateUserImg } from "@/api/user"
export default {
  components: {
    CommonHeader,
    ChangePass,
    ImageEdit
  },
  data() {
    return {
      userinfo_last: {},
      userinfo: {},
      showEditPassword: false,
      showEditImage: false,
      editFile: null,
      editImage: null
    }
  },
  computed: {
    last_login_time: function() {
      return this.unix2timestamp(this.userinfo_last["lastLoginTime"])
    }
  },
  methods: {
    initData() {
      this.userinfo_last = JSON.parse(localStorage.getItem("user_info_last"))
      this.userinfo = JSON.parse(localStorage.getItem("user_info"))
    },
    unix2timestamp(value) {
      if (!value) return null
      let date = new Date(parseInt(value) * 1000)
      let Y = date.getFullYear() + "-"
      let M = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) + "-" : date.getMonth() + 1 + "-"
      let D = date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " "
      let h = date.getHours() < 10 ? "0" + date.getHours() + ":" : date.getHours() + ":"
      let m = date.getMinutes() < 10 ? "0" + date.getMinutes() + ":" : date.getMinutes() + ":"
      let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    changePersonImage() {
      document.getElementById("inputFile").click()
    },
    submitCropperImage(data) {
      // console.log(data)
      //1 上传原始图片
      //2 处理原始图片传给vue-cropper组件，vue-cropper通过getCropBlob处理得到png图片的blob格式,并从getPropData得到该图片的预览格式previewImage
      //3 通过getCropBlob返回生成的png图片blob格式并上传服务器
      //console.log("提交成功")

      var param = new FormData()
      param.append("id", this.userinfo["uid"])
      param.append("file", data.file)
      param.append("base64_image", data.image)
      //这里把原图片的信息传到后台了，但cropper的base64图片怎么传到后台的？
      updateUserImg(param).then(res => {
        this.$message({
          type: res.type,
          message: res.message
        })
      })
      //重新请求数据，以便刷新新头像,直接刷新最快
      //location.reload()
      // this.$nextTick(function() {
      //   location.reload()
      // })
      setTimeout(() => {
        location.reload()
      }, 600)
    },
    editClick(type) {
      if (type == "password") {
        this.showEditPassword = true
      } else if (type == "back") {
        this.$router.go(-1)
      }
    },
    uploadFile(event) {
      var files = event.target.files
      const file = files[0]
      const reader = new FileReader()
      var self = this
      reader.onload = function(e) {
        let result
        if (typeof e.target.result === "object") {
          // 把Array Buffer转化为blob 如果是base64不需要
          result = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          result = e.target.result
        }
        self.editImage = result
        self.editFile = file
        self.showEditImage = true
        e.target.value = ""
      }
      reader.readAsDataURL(file)
      this.$refs.uploadInput.value = null
    }
  },
  created() {
    this.initData()
  }
}
</script>

<style lang="scss">
.el-header {
  -webkit-box-shadow: 0px 1px 2px #dbdbdb;
  box-shadow: 0px 1px 2px #dbdbdb;
  z-index: 100;
}
.el-container {
  height: 100%;
  .el-container {
    //border: 1px solid green;
    //height: calc(100% - 60px) !important;
    height: calc(100% - 68px);
    .el-main {
      .personal-container {
        width: 900px;
        min-width: 900px;
        margin: 0 auto;
        height: 100%;
        border: 1px solid #e6e6e6;
        background-color: white;
        border-radius: 2px;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 7px;
          height: 7px;
          background-color: #f5f5f5;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
          background-color: #c8c8c8;
        }
        .header-handle {
          float: right;
          padding: 10px 30px;
        }
        .personal-info {
          padding: 0 80px 30px;
          position: relative;
          width: 100%;
          text-align: left;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          display: -webkit-flex;
          box-align: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          .person-head {
            .person-head-img {
              display: block;
              width: 120px;
              height: 120px;
              border-radius: 60px;
              margin-right: 35px;
              cursor: pointer;
              background-size: 100% 100%;
              background-repeat: no-repeat;
            }
            .select-picture {
              position: absolute;
              display: none;
              z-index: 3;
              top: 0;
              left: 80px;
              width: 120px;
              height: 120px;
              border-radius: 60px;
              background-color: rgba(0, 0, 0, 0.2);
              text-align: center;
              cursor: pointer;
              div {
                cursor: pointer;
                margin-top: 55px;
                color: #fff;
                font-size: 12px;
              }
            }
          }
          .person-head:hover {
            .select-picture {
              display: block;
            }
          }
          .person-body {
            .person-name {
              font-size: 25px;
              margin-bottom: 15px;
            }
            .person-detail {
              font-size: 12px;
              color: #777;
              margin-top: 22px;
            }
          }
        }
        .segmentation {
          height: 4px;
          background-color: #f5f6f9;
        }
        .section {
          padding: 30px 80px;
          position: relative;
          background-color: white;
          margin-top: 8px;
          .section-mark {
            border-left: 2px solid #409eff;
            height: 10px;
          }

          .section-header {
            display: flex;
            align-items: center;
            padding: 5px 15px;
          }
          .section-title {
            font-size: 13px;
            color: #333;
            margin-left: 8px;
            flex-shrink: 0;
          }
        }
        .content {
          position: relative;
          padding: 10px 20px;
          width: 100%;
          text-align: left;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          display: -webkit-flex;
          box-align: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          flex-direction: row;
          flex-wrap: wrap;
        }

        .info-cell {
          padding: 8px 10px;
          flex: 0 0 50%;
          &-box {
            width: auto;
            padding: 8px;
            box-direction: row;
            box-orient: horizontal;
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
            -ms-flex-direction: row;
            flex-direction: row;
            text-align: left;
            display: -webkit-flex;
            -webkit-box-align: center;
            align-items: stretch;
            &-name {
              width: 100px;
              margin-right: 10px;
              font-size: 12px;
              flex-shrink: 0;
              color: #777;
            }
            &-value {
              font-size: 12px;
              color: #333;
            }
          }
        }

        #inputFile {
          display: none;
        }
      }
      background: #f5f6f9;
    }
  }
}
</style>
